const BlogVideoWithCaption = ({src, caption, ...props}) => {
  return (
    <div className="relative flex flex-col items-center">
      <video controls muted autoPlay loop className="!mb-2" src={src} {...props}>
        <source src={src} type="video/mp4" />
      </video>
      <span className="text-sm italic">{caption}</span>
    </div>
  );
};

export default BlogVideoWithCaption;
